<template>
    <el-dialog :title="title" class="operate_station_dialog" :visible="visible" :before-close="handleClose" :close-on-click-modal="false">
        <el-form>
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="企业名称" prop="companyName">
                            <el-input v-model="form.companyName" @input="handleNameInput"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="社会信用代码" prop="societyCreditCode">
                            <el-input v-model="form.societyCreditCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="货站地址" prop="areaList">
                            <el-row :gutter="0">
                                <el-col :span="12">
                                    <address-select
                                        :clearable="true"
                                        v-model="form.areaList"
                                        :minLayers="3"
                                    />
                                </el-col>
                                <el-col :span="12"><map-input ref="mapInputRef" popperClass="operate-station-popper" @setSelectedAddress="setSelectedAddress" /></el-col>
                            </el-row>
                            <!-- <div class="address-form-item">
                                <el-input v-model="form.stationAddress"></el-input>
                                <map-input />
                            </div> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="货站名称" prop="stationEditName">
                            <el-row>
                                <el-col :span="12">
                                        <el-input v-model="form.stationEditName"></el-input>
                                    </el-col>
                                <el-col :span="12">
                                        <el-input v-model="form.stationName" disabled></el-input>
                                    </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import AddressSelect from '@/components/lots/otpCascader2';
import MapInput from './mapInput/Index.vue';
import { getCreditCodeByName, addStation, updateStation } from '../../../../../../api/register/cargoStationInfo.js';

const DEFAULT_FORM = {
    companyName: '',
    societyCreditCode: '',
    areaList: [],
    stationAddress: '',
    provinceCode: '',
    cityCode: '',
    districtCode: '',
    provinceName: '',
    cityName: '',
    districtName: '',
    stationName: '',
    stationEditName: '',
    lng: '',
    lat: ''
};
let inputDebounce = null;
export default {
    name: 'operateStationDialog',
    components: { AddressSelect, MapInput },
    props: { },
    data() {
        return {
            loading: false,
            title: '',
            visible: false,
            rules: {
                companyName: [{ required: true, message: '请输入企业名称', trigger: ['blur', 'change'] }],
                societyCreditCode: [{ required: true, message: '请输入企业名称获取社会信用代码', trigger: ['blur', 'change'] }],
                areaList: [{ required: true, message: '请选择货站地址', trigger: ['blur', 'change'] }],
                stationEditName: [{ required: true, message: '请输入货站名称', trigger: ['blur', 'change'] }]
            },
            currentId: null,
            initSocietyCreditCode: null,
            version: null,
            form: JSON.parse(JSON.stringify(DEFAULT_FORM))
        };
    },
    computed: {
        ...mapState(['supplier']),
        supplierCode() {
            return this.supplier ? this.supplier.supplierCode : this.$route.query.supplierCode;
        }
    },
    methods: {
        open(row) {
            this.visible = true;
            this.$nextTick(() => {
                this.title = row ? '货站信息修改' : '货站信息新增';
                this.initForm(row);
                this.$refs.mapInputRef.init({
                    provinceName: this.form.provinceName,
                    cityName: this.form.cityName,
                    districtName: this.form.districtName,
                    fullAddress: this.form.stationAddress
                });
            });
        },
        initForm(row) {
            if (!row) {
                this.currentId = null;
                this.version = null;
                return false;
            }
            this.currentId = row.id;
            this.initSocietyCreditCode = row.societyCreditCode;
            this.version = row.version;
            this.form.companyName = row.companyName;
            this.form.societyCreditCode = row.societyCreditCode;
            this.form.provinceCode = row.provinceCode;
            this.form.provinceName = row.provinceName;
            this.form.cityCode = row.cityCode;
            this.form.cityName = row.cityName;
            this.form.districtCode = row.districtCode;
            this.form.districtName = row.districtName;
            this.form.areaList = [row.provinceCode, row.cityCode, row.districtCode];
            this.form.stationAddress = row.stationAddress;
            this.form.stationName = row.stationName;
            this.form.stationEditName = row.stationEditName;
            this.form.lng = row.lng;
            this.form.lat = row.lat;
        },
        setSelectedAddress(data) {
            this.form.provinceCode = data.ProvinceCode;
            this.form.provinceName = data.ProvinceName;
            this.form.cityCode = data.CityCode;
            this.form.cityName = data.CityName;
            this.form.districtCode = data.DistrictCode;
            this.form.districtName = data.DistrictName;
            this.form.stationAddress = data.DetailAddr;
            this.form.areaList = [data.ProvinceCode, data.CityCode, data.DistrictCode];
            this.form.lng = data.Lng;
            this.form.lat = data.Lat;
        },
        handleNameInput(val) {
            inputDebounce && inputDebounce.cancel();
            inputDebounce = _.debounce(() => {
                this.form.societyCreditCode = '';
                getCreditCodeByName({ companyName: val }).then(res => {
                    if (res && +res.code === 0) {
                        this.form.societyCreditCode = res.data;
                    }
                });
            }, 1000);
            inputDebounce();
        },
        handleConfirm() {
            this.$refs.ruleForm.validate().then(valid => {
                if (!valid) return false;
                let apiFunc = addStation;
                let successMsg = '新增货站信息成功!';
                if (this.currentId) {
                    if (this.initSocietyCreditCode !== this.form.societyCreditCode) {
                        this.$message.warning('不可修改社会信用代码!');
                        return false;
                    }
                    apiFunc = updateStation;
                    successMsg = '修改货站信息成功!';
                }
                this.loading = true;
                apiFunc(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(successMsg);
                        this.handleClose();
                        this.$emit('success');
                    }
                }).finally(() => { this.loading = false; });
            }).catch(e => {});
        },
        getParams() {
            const params = JSON.parse(JSON.stringify(this.form));
            if (this.currentId) {
                params.id = this.currentId;
                params.version = this.version;
            }
            params.supplierCode = this.supplierCode;
            delete params.areaList;
            return params;
        },
        handleClose() {
            this.clear();
            this.visible = false;
        },
        clear() {
            this.currentId = null;
            this.initSocietyCreditCode = null;
            this.version = null;
            this.form = JSON.parse(JSON.stringify(DEFAULT_FORM));
            this.$refs.ruleForm.clearValidate();
        }
    }
};
</script>
<style lang="less">
.operate_station_dialog {
    // .el-form-item {
    //     margin-bottom: 10px;
    // }
    // .address-form-item {
    //     display: flex;
    // }
    .baidu_map_input {
        margin-top: 6px;
    }
    .el-form-item__error {
        padding-top: 0px;
    }
}
.operate-station-popper {
    width: 32% !important;
}
</style>